import printIcon from './printer.svg';
export default printIcon;